import { h, Component } from "preact";
import { css } from "emotion";
import SocialMedia from "./SocialMedia";
import { hexToRgba } from "../../utils/Format";

const styles = {
  headerContainer: css`
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    box-shadow: 0 1px 10px 2px rgba(32, 7, 64, 0.13);
    border-radius: 0px 0px 4px 4px;
    @media (max-width: 600px) {
      margin-bottom: 24px;
      max-width: 100%;
    }
  `,
  button: css`
    background: transparent;
    border: none;
    padding: 0;
    padding-top: 9px;
    width: 50px;
    margin-right: 20px;
    @media (max-width: 600px) {
      padding-top: 2px;
      font-size: 14px;
    }
  `
};

/**
 * Display tab bar, title, and banner image
 *
 * @param {*} props
 * @returns
 */
const Header = props => {
  const {
    tour,
    selectTab,
    selectedTab = "events",
    showSocialModal = false
  } = props;

  const customStyles = {
    bannerImage: css`
      background: url(${tour.bannerImage.url}) center center / cover no-repeat
        rgb(238, 238, 238);
      width: 100%;
      max-width: 1000px;
      height: 100%;
      height: 500px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 50%;
      position: relative;
      @media (max-width: 600px) {
        height: 160px;
      }
    `,
    titleBelow: css`
      font-size: 32px;
      font-weight: 600;
      text-align: center;
      padding-top: 13px;
      padding-bottom: 12px;
      border-bottom: solid 1px #ffffff;
      color: ${tour.theme.titleTextColor};
      background-color: ${hexToRgba(
        tour.theme.titleBackgroundColor,
        tour.theme.cardAndBarOpacity
      )};
      @media (max-width: 600px) {
        font-size: 18px;
      }
    `,
    titleInside: css`
      height: 50px;
      font-size: 32px;
      font-weight: 600;
      text-align: center;
      padding: 4px 8px;
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      @media (max-width: 600px) {
        font-size: 18px;
      }
    `,
    title: css`
      color: ${tour.theme.titleTextColor};
      background-color: ${tour.theme.titleBackgroundColor};
      padding-left: 8px;
      padding-right: 8px;
    `,
    linkItem: css`
      padding-top: 4px;
      padding-bottom: 5px;
      color: ${tour.theme.eventCardBackgroundColor === "#ffffff"
        ? tour.theme.cardTitleColor
        : "#ffffff"};
    `,
    selectedItem: css`
      padding-top: 4px;
      padding-bottom: 3px;
      font-weight: 600;
      border-bottom: 3px solid ${tour.theme.primaryColor};
      color: ${tour.theme.eventCardBackgroundColor === "#ffffff"
        ? tour.theme.cardTitleColor
        : "#ffffff"};
      @media (max-width: 600px) {
        padding-bottom: 5px;
      }
    `,
    socialMedia: css`
      display: ${showSocialModal ? "inherit" : "none"};
      float: right;
      margin-top: 10px;
      @media (max-width: 900px) {
        display: inherit;
        float: right;
        margin-top: 5px;
      }
    `,
    linkRow: css`
      height: 44px;
      padding: 0px 16px 0px 26px;
      font-size: 16px;
      background-color: ${hexToRgba(
        tour.theme.eventCardBackgroundColor,
        tour.theme.cardAndBarOpacity
      )};
      border-radius: 0px 0px 4px 4px;
      @media (max-width: 600px) {
        border-radius: 0px;
        height: 36px;
      }
    `
  };
  return (
    <div className={styles.headerContainer}>
      {tour.bannerImage.url && tour.bannerImage.url !== "" ? (
        <div className={customStyles.bannerImage}>
          {tour.settings.showName &&
          tour.settings.namePlacement === "inside" ? (
            <div className={customStyles.titleInside}>
              <span className={customStyles.title}>{tour.name}</span>
            </div>
          ) : null}
        </div>
      ) : null}
      {tour.settings.showName && tour.settings.namePlacement === "below" ? (
        <div className={customStyles.titleBelow}>{tour.name}</div>
      ) : null}
      <div className={customStyles.linkRow}>
        <button onClick={() => selectTab("events")} className={styles.button}>
          <div
            className={
              selectedTab === "events"
                ? customStyles.selectedItem
                : customStyles.linkItem
            }
          >
            Events
          </div>
        </button>
        <button onClick={() => selectTab("about")} className={styles.button}>
          <div
            className={
              selectedTab === "about"
                ? customStyles.selectedItem
                : customStyles.linkItem
            }
          >
            About
          </div>
        </button>
        <div className={customStyles.socialMedia}>
          <SocialMedia
            modal={true}
            slug={tour.slug}
            eventCardBackgroundColor={tour.theme.eventCardBackgroundColor}
            cardAndBarOpacity={tour.theme.cardAndBarOpacity}
          />
        </div>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./routes/tours/Header.js